<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> GRADE </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="grid.id"
          >{{ grid.id }} - {{ grid.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :visible="!!alert_message"
        dark
        :type="type_alert"
        :message="alert_message"
        :clickClose="() => (alert_message = '')"
      />
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4">
              <v-text-field
                v-model="grid.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="2">
              <v-select
                :items="typesGrid"
                v-model="grid.type"
                label="Tipo"
                required
                dense
                outlined
                :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col cols="12" xs="12" md="2">
              
            </v-col> -->
            <v-col
              cols="12"
              xs="12"
              sm="6"
              md="4"
              v-if="grid.type === 'fechada'"
            >
              <v-text-field
                v-model="grid.closed_grid"
                class="text-field-uppercase"
                label="Quantidades Grade Selecionável"
                dense
                outlined
                messages="Separar com ponto e virgula (;)"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="6"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="3"> Grade </v-col>
            <v-col cols="12" xs="9">
              <v-text-field
                v-for="(item, index) in grids"
                :key="item"
                style="
                  width: 70px;
                  font-size: 12px;
                  display: inline;
                  float: left;
                  margin-left: 2px;
                "
                v-model="sizes[index]"
                :append-outer-icon="showIconLastSize(index)"
                @click:append-outer="removeLastSize"
                dense
                hide-details
                outlined
                required
              >
              </v-text-field>
              <v-btn class="ml-5" color="green" dark @click="addGrid">
                <v-icon dark left> mdi-plus </v-icon>
                Adicionar Tamanho
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" xs="3"> Quantidades </v-col>
            <v-col cols="12" xs="9">
              <v-text-field
                v-for="(item, index) in grids"
                :key="item"
                style="
                  width: 70px;
                  font-size: 12px;
                  display: inline;
                  float: left;
                  margin-left: 2px;
                "
                v-model.number="amount[index]"
                dense
                hide-details
                outlined
                required
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/requests/GridRequest";
import Alert from "@/components/Alert";
export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    grid: {
      id: "",
      name: "",
      type: "aberta",
      closed_grid: "",
      status: 1,
    },
    grids: [],
    amount: [],
    sizes: [],
    typesGrid: [
      { value: "aberta", text: "Digitável" },
      { value: "fechada", text: "Selecionável" },
    ],
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    alert_message: "",
    type_alert: "",
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getGrid(this.$route.params.id);
      }
    },
    async getGrid(id) {
      this.loading = true;
      try {
        this.grid = await API.getById(id);
        this.grids = this.grid.sizes.map((item) => item.size);
        this.sizes = [...this.grids];
        this.amount = this.grid.sizes.map((item) => item.amount_express);
      } catch (error) {
        this.grid = {};
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "Grid" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.grid.name = this.grid.name.toUpperCase();
        // this.grid.type = "aberta";
        this.grid.amount = this.amount;
        this.grid.sizes = this.sizes;
        let data = this.grid;
        if (this.grid.id === "") {
          this.post(data);
        } else {
          this.update(this.grid.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        await API.post(data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message = error.message;
        this.type_alert = "error";
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        await API.update(id, data);
        this.goToBackList();
      } catch (error) {
        console.log(error);
        this.alert_message = error.message;
        this.type_alert = "error";
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
    addGrid() {
      let lastValue = this.sizes[this.sizes.length - 1];
      if (lastValue == "") {
        return false;
      }
      if (this.sizes.length === 0) {
        this.sizes.push("");
      } else {
        let maxSize = this.sizes[this.sizes.length - 1];
        if (!isNaN(maxSize)) {
          maxSize++;
          this.sizes.push(maxSize);
        } else {
          this.sizes.push("");
        }
      }
      this.grids = [...this.sizes];
      this.amount.push(0);
    },
    showIconLastSize(index) {
      return index !== 0 && index === this.sizes.length - 1 ? "mdi-delete" : "";
    },
    removeLastSize() {
      this.grids.pop();
      this.sizes.pop();
      this.amount.pop();
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
